<template>
    <VButton class="app-button">
        <slot></slot>
    </VButton>
</template>

<script setup lang="ts">
    import VButton from "@/components/elements/VButton.vue";
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";

    .app-button {
        transition-duration: 0.2s;

        &.primary {
            background-color: var(--colorPrimary);
            border-color: var(--colorPrimary);

            &:hover,
            &:active {
                background-color: var(--colorPrimaryHover);
                border-color: var(--colorPrimaryHover);
            }
        }

        &.warning {
            background-color: colors.$orange;
            border-color: colors.$orange;

            &:hover,
            &:active {
                background-color: colors.$orangeHover;
                border-color: colors.$orangeHover;
            }
        }
    }
</style>
